import styled, { css } from 'styled-components';
import ProductImage from '@prisjakt/ui-product-image';
import { layout, colors, styledUtils } from '@prisjakt/ui-base';
import ProductCheckbox, {
  productCheckboxHoverStyle,
} from '@prisjakt/ui-product-checkbox';
import { Link } from 'react-router-dom';
import ShippingLabelComponent from '../../../../../components/shipping-label';

export const ListUl = styled.ul`
  list-style: none;
  margin-top: ${layout.spacing.xSmall};
`;

type ListItemProps = { selected?: boolean };
export const ListItem = styled.li<ListItemProps>`
  border-bottom: 1px solid ${({ theme }) => theme.lines.secondary};
  display: grid;
  grid-template-columns: auto 1fr auto;
  justify-items: start;
  align-items: center;
  padding: ${layout.spacing.xSmall};
  width: 100%;
  cursor: pointer;
  position: relative;

  ${props =>
    props.selected &&
    css`
      &::before {
        ${styledUtils.overlay(props.theme.bg.productCompareLight)}
      }
    `}

  &:focus-within::after {
    ${styledUtils.overlay()}
  }
`;

export const CheckboxAndImageColumn = styled.div`
  display: flex;
`;

export const ImageContainer = styled.div`
  width: 45px;
  box-sizing: content-box;
  padding-right: ${layout.spacing.xSmall};
`;

export const ListImage = styled(ProductImage)`
  height: 40px;
  width: 40px;
`;

export const ProductName = styled.h3`
  font: inherit;
  font-size: ${layout.measurements.fontSizeSmall};
  padding-right: ${layout.spacing.xSmall};
  color: ${colors.darkBlue1};
  margin-bottom: ${layout.spacing.xxSmall};
`;

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const ProductLink = styled(Link)``;

export const ShippingLabel = styled(ShippingLabelComponent)`
  font-size: ${layout.measurements.fontSizeSmall};
`;

export const CompareCheckbox = styled(ProductCheckbox)`
  margin-right: ${layout.spacing.xSmall};

  ${/* sc-selector */ ListItem}:hover &,
  ${/* sc-selector */ ListItem}:focus-within & {
    ${productCheckboxHoverStyle}
  }
`;
